//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        isPrimary: {
            default: false,
        }
    }
}
